module.exports = __webpack_public_path__ + "static/img/img_6.3dcd1498.jpg";